export default "__VITE_ASSET__t$vqXia2__"